import { useEffect, useState } from "react";
import { Download, EnvelopeSimple } from "@phosphor-icons/react";
import { api, authHeaders, BASE_URL, getToken } from "@/lib/api";
import PageHeader from "@/admin/components/PageHeader";

export default function Subscribers() {
    const [subs, setSubs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/admin/subscribers", { headers: authHeaders() })
            .then((r) => setSubs(r.data.subscribers || []))
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    const downloadUrl = `${BASE_URL}/api/admin/subscribers.csv?token=${encodeURIComponent(getToken() || "")}`;

    return (
        <div data-testid="admin-subscribers">
            <PageHeader
                kicker="Marketing"
                title="Email subscribers"
                action={
                    <a
                        href={downloadUrl}
                        data-testid="export-csv"
                        className="inline-flex items-center gap-2 rounded-full bg-foreground text-background px-5 py-2.5 font-bold uppercase tracking-widest text-xs hover:-translate-y-0.5 transition"
                    >
                        <Download size={16} weight="bold" />
                        Export CSV
                    </a>
                }
            />

            <div className="bg-white rounded-2xl border border-border overflow-hidden">
                {loading ? (
                    <div className="p-12 text-center text-muted-foreground">Loading...</div>
                ) : subs.length === 0 ? (
                    <div data-testid="subs-empty" className="p-12 text-center text-muted-foreground">
                        <EnvelopeSimple size={40} weight="duotone" className="mx-auto mb-3 opacity-40" />
                        No subscribers yet.
                    </div>
                ) : (
                    <table className="w-full text-sm" data-testid="subs-table">
                        <thead className="bg-muted/40">
                            <tr className="text-left text-[11px] uppercase tracking-widest text-muted-foreground">
                                <th className="px-4 py-3">Email</th>
                                <th className="px-4 py-3">Source</th>
                                <th className="px-4 py-3">Captured</th>
                            </tr>
                        </thead>
                        <tbody>
                            {subs.map((s, i) => (
                                <tr key={i} className="border-t border-border" data-testid={`sub-row-${i}`}>
                                    <td className="px-4 py-3 font-semibold">{s.email}</td>
                                    <td className="px-4 py-3 text-muted-foreground">{s.source || "—"}</td>
                                    <td className="px-4 py-3 text-muted-foreground text-xs">
                                        {s.created_at ? new Date(s.created_at).toLocaleString() : "—"}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>

            <p className="mt-4 text-xs text-muted-foreground">
                {subs.length} {subs.length === 1 ? "subscriber" : "subscribers"} captured.
            </p>
        </div>
    );
}
